// extracted by mini-css-extract-plugin
module.exports =  {"rssStyle":"RssDirective_rssStyle__b-K1o","muted":"RssDirective_muted__wCC3x"};